import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar'
import Swal from 'sweetalert2';
import { getAllEnquiries, deleteEnquiry } from '../api/auth/Enquiry';

function OtherProductDetails() {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getAllEnquiries();
            setData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire(
                'Error!',
                'There was a problem fetching enquiries.',
                'error'
            );
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteEnquiry(id);
                    setData(data.filter(item => item.id !== id));
                    Swal.fire(
                        'Deleted!',
                        'The enquiry has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting enquiry:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the enquiry.',
                        'error'
                    );
                }
            }
        });
    };
    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '210px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="page-title">Other Product Details</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-10 mt-3" style={{ marginLeft: '210px' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Enquiry for</th>
                            <th scope="col">Address</th>
                            <th scope="col">Message</th>
                            <th scope="col">Date</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>{item.email}</td>
                                <td>{item.phone}</td>
                                <td>{item.enquiryfor}</td>
                                <td>{item.address}</td>
                                <td>{item.message}</td>
                                <td>{item.date || 'N/A'}</td>
                                <td>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default OtherProductDetails
